import React, { Component } from 'react'
import { MagicInput } from 'hljd'

export default class extends Component {
  render() {
    const { value, onChange, ...rest } = this.props
    return (
      <MagicInput
        placeholder="请输入婚策案例标题，建议名称总长度在12-24字"
        style={{ width: 500 }}
        maxLength={24}
        showCount
        countPosition="right"
        value={value}
        onChange={e => onChange(e.target.value)}
        {...rest}
      />
    )
  }
}
